import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncSelectEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-jql-builder-base-picker-select" */ './main').then(
			(module) => module.PaginatedAsyncSelectViewExperience,
		),
	),
	getPreloadProps: () => ({}),
});
